import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e2f7ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-box" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "left-title" }
const _hoisted_5 = {
  key: 0,
  class: "left-middle-text fix-margin-t-16 serial-number-text"
}
const _hoisted_6 = {
  key: 1,
  class: "left-middle-text fix-margin-t-16"
}
const _hoisted_7 = {
  key: 2,
  class: "left-middle-text"
}
const _hoisted_8 = {
  key: 3,
  class: "left-middle-text fix-margin-b-16"
}
const _hoisted_9 = {
  key: 4,
  class: "left-bottom-text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "card-actions"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "action-right" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "footer-title"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本页面仅显示无人机设备首次激活时领取的无人机第三者责任险服务；", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 首年领取的第三者责任险服务到期后，可前往极飞农服APP“我的 - 服务 - 保险”购买第三者责任险，保险服务由平安提供。 ", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "footer-title"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "若首次激活设备时未领取设备第三者责任险，请咨询客服；", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "如需自行购买保险请前往极飞农服APP“我的 - 服务 - 保险”自行购买。", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "popup-select-container" }
const _hoisted_25 = { class: "popup-top xag-flex-lr" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "修改被保人", -1))
const _hoisted_27 = { class: "edit-block" }
const _hoisted_28 = { class: "edit-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "被保人名称", -1))
const _hoisted_30 = { class: "edit-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "证件类型", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right" }, null, -1))
const _hoisted_33 = { class: "edit-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "被保人证件编码", -1))
const _hoisted_35 = { class: "popup-bottom form-footer device-replace-button-wrap" }
const _hoisted_36 = { class: "popup-select-container" }
const _hoisted_37 = { class: "popup-top xag-flex-lr" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "证件类型", -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-selected-svg" }, null, -1))
const _hoisted_41 = { class: "popup-bottom form-footer device-replace-button-wrap" }

import AppHeader from '@/components/Header.vue'
import { onMounted, onActivated, ref, computed, ComputedRef, reactive, withDefaults } from 'vue'
import { tagSatus, serviceTagSatusItem, insuranceTypeItem } from '@/types/three-liability-insurance'
import {
  getPingAnInsuranceList,
  printGAC,
  getlastXcare,
  editPPICThirdPartyLiability,
} from '@/apis/three-liability-insurance'
import { Toast, Dialog, Popup, Button, Field, Divider } from 'vant'
import { AxiosError } from 'axios'
import { serviceType, serviceItem } from '@/types/three-liability-insurance'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'
import AppHost from '@/utils/app'
import { insurantTypeOptions } from './common'
import { getThirdPartyInsuranceStatusSortWeight } from '@/views/insurance/common'
import {
  InsurantTypeOptionsItem,
  EditPPICThirdPartyLiabilityParams,
} from '@/types/three-liability-insurance'
import { validateIDCard } from '@/utils/index'
import { InsuranceThirdPartyDronePingan2024DataStorage } from '@/storage/insurance'
import { showToastLoading, showToastSuccess, clearToast, showConfirmModal } from '@/utils/tools'

type PageItem = {
  pageTitle: string
  serial_number: string
  status: number // 1生效 2 失效
  begin_date?: string
  end_date?: string
  text: string
  background: string
  policy_no?: string // 保单号
  insurant_name?: string
  insurance_type?: number // 2平安 5人保
  insurance_type_company?: string // 承保公司 平安/人保
  api_type?: number // 1  旧平安  2人保  3 平安2024线上 4 平安2024线下
  insurant_phone_no?: string // 联系人号码
  voucher_url?: string
  sourceData?: serviceItem
}


export default /*#__PURE__*/_defineComponent({
  __name: 'third-party-drone',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };

const THIRD_PARTY_DETAIL_REFRESH_KEY = 'thirdPartyLiabilityDetailNeedRefresh'

const onLeftClick = function () {
  AppHost.goAppBack()
}


const router = useRouter()
const route = useRoute()
const sn = route.query.sn
const SType = route.query.type
const isThirdPartyLiability = computed(() => {
  return SType === serviceType.ThirdPartyLiabilityService
})

let Page = ref<{
  title: string
  data: PageItem[]
}>({
  title: '',
  data: [],
})
let cacheThirdPartyDroneData: serviceItem | null = null
const status: tagSatus<serviceTagSatusItem> = {
  0: {
    text: '无服务',
    background: 'rgba(0,0,0,0.22)',
  },
  1: {
    text: '保障中',
    background: 'rgba(57, 181, 74, 1)',
  },
  2: {
    text: '已到期',
    background: 'rgba(247,152,28,1)',
  },
  3: {
    text: '待生效',
    background: 'rgba(247,152,28,1)',
  },
}

const insuranceTypeMap: insuranceTypeItem = {
  '2': '中国平安财产保险股份有限公司',
  '5': '中国人民财产保险股份有限公司',
}

function isPPICInsuranceItem(item: PageItem) {
  return item.insurance_type === 5
}

function isPingan2024OnlineItem(item: PageItem) {
  return item.api_type === 3
}

function isPingan2024OfflineItem(item: PageItem) {
  return item.api_type === 4
}

function isItemActive(item: PageItem) {
  return item.status === 1
}

function mapServiceItemToPageItem(data: serviceItem): PageItem {
  const statusValue = data.status ?? 0
  const statusInfo = status[statusValue] || status[0]
  const insuranceType = data.insurance_type || 2
  return {
    policy_no: data.policy_no || '',
    text: statusInfo.text,
    background: statusInfo.background,
    status: statusValue,
    insurant_name: data.insurant_name,
    pageTitle: data.product_name || '设备第三者责任险',
    begin_date: data.policy_begin_date
      ? dayjs(Number(data.policy_begin_date) * 1000).format('YYYY-MM-DD HH:mm')
      : '',
    end_date: data.policy_end_date
      ? dayjs(Number(data.policy_end_date) * 1000).format('YYYY-MM-DD HH:mm')
      : '',
    serial_number: data.serial_number,
    insurance_type: insuranceType,
    insurance_type_company: insuranceTypeMap[insuranceType + ''],
    api_type: data.api_type,
    insurant_phone_no: data.insurant_phone_no,
    voucher_url: data.voucher_url,
    sourceData: data,
  }
}

function getPrintGacCacheKey(policyNo: string) {
  return `printGAC${sn}_${policyNo}`
}

const extremeServiceStatus: {
  [props: string]: {
    statusNumber: number
    background: string
  }
} = {
  notService: {
    statusNumber: 0,
    background: 'rgba(0,0,0,0.22)',
  },
  wait_effective: {
    statusNumber: 1,
    background: 'rgba(57, 181, 74, 1)',
  },
  protect: {
    statusNumber: 2,
    background: 'rgba(57, 181, 74, 1)',
  },
  overdue: {
    statusNumber: 3,
    background: 'rgba(247,152,28,1)',
  },
  disable: {
    statusNumber: 3,
    background: 'rgba(0,0,0,0.22)',
  },
}
function toOfflineHandlePage() {
  router.push({
    name: 'pingan-offline-page',
  })
}

// 与改版前列表行一致的显示/点击逻辑
// 下载：item.status !== 0
function canShowDownloadPolicy(item: PageItem) {
  return item.status !== 0
}

// 操作员：仅平安且 status === 1（保障中）时显示
function canShowOperator(item: PageItem) {
  return !isPPICInsuranceItem(item) && item.status === 1
}

// 批改/修改被保人：保障中、待生效时可显示
function canShowCorrectInsured(item: PageItem) {
  return item.status === 1 || item.status === 3
}

function handleCorrectInsuredClick(item: PageItem) {
  if (isPPICInsuranceItem(item)) {
    changeInsuredPPIC(item)
    return
  }
  toCorrectSelectPage(item)
}

function toCorrectSelectPage(item: PageItem) {
  router.push({
    name: 'third-party-correct-select',
    query: {
      sn: item.serial_number || (sn as string),
    },
  })
}

function operator(item: PageItem) {
  if (!isItemActive(item) || isPPICInsuranceItem(item)) {
    return
  }
  const sourceData = item.sourceData
  if (!sourceData) {
    return
  }
  if (isPingan2024OfflineItem(item)) {
    toOfflineHandlePage()
    return
  }
  if (isPingan2024OnlineItem(item)) {
    InsuranceThirdPartyDronePingan2024DataStorage.set(sourceData)
    router.push({
      name: 'add-pingan2024-operator',
      query: {
        sn,
      },
    })
    return
  }
  const cacheKey = `thirdPartyDroneCacheKey_${item.policy_no || sn}`
  sessionStorage.setItem(cacheKey, JSON.stringify(sourceData))
  router.push({
    name: 'operator',
    query: {
      sn,
      cacheKey,
    },
  })
}

async function downloadEPolicy(item: PageItem) {
  let url = item.voucher_url || ''
  if (!url && !isPPICInsuranceItem(item) && item.policy_no) {
    showToastLoading()
    url = (await updatePinganPrintGac(item.policy_no, false)) || ''
    if (url) {
      item.voucher_url = url
    }
    clearToast()
  }
  if (!url) {
    Dialog.alert({
      message: '凭证处理中，处理完成即可下载。一般2-3个工作日内处理完成。',
      confirmButtonText: '我知道了',
      className: 'device-replace-dialog',
      width: 304,
    })
    return
  }
  AppHost.openBrowser(url)
}
const pHeightMax: ComputedRef<number> = computed(() => {
  const height = window.innerHeight
  return height * 0.9
})
// 人保批改提交参数
let parameter = reactive({
  policy_no: '', // 保单号
  insurant_name: '', // 被保险人名称
  insurant_type: '', // 证件类型 1身份证 2社会信用代码 3工商注册号
  insurant_type_text: '', // 证件类型text
  insurant_certi_no: '', // 被保险人证件号
})
const insuredPPICEditShow = ref(false)
function changeInsuredPPIC(insurance: PageItem) {
  if (
    !insurance.policy_no ||
    (insurance.status !== 1 && insurance.status !== 3) ||
    !isPPICInsuranceItem(insurance)
  ) {
    return Toast('无有效保单号或当前保单不支持修改')
  }
  // 数据重置
  parameter.policy_no = insurance.policy_no
  parameter.insurant_name = ''
  parameter.insurant_type = ''
  parameter.insurant_type_text = ''
  parameter.insurant_certi_no = ''
  insuredPPICEditShow.value = true
}
async function confirmEditSuranceInfo() {
  const params = {
    policy_no: parameter.policy_no,
    insurant_name: parameter.insurant_name,
    insurant_type: parameter.insurant_type,
    insurant_certi_no: parameter.insurant_certi_no,
  }
  console.log('批改保单-params', params)
  if (!verifyParameter(params)) {
    return
  }
  showToastLoading({
    message: '正在修改',
  })
  try {
    await editPPICThirdPartyLiability(params)
    clearToast()
    showToastSuccess('保单修改成功')
    insuredPPICEditShow.value = false
    setTimeout(() => {
      thirdPartyLiabilityData()
    }, 2000)
  } catch (error: any) {
    clearToast()
    let message = error && error.message ? error.message : '信息修改失败'
    Dialog({
      message,
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      width: 304,
    })
  }
}
function verifyParameter(params: EditPPICThirdPartyLiabilityParams): boolean {
  let message = ''
  if (!params.insurant_name) {
    message = '请填写被保人名称'
  } else if (!params.insurant_type) {
    message = '请选择证件类型'
  } else if (!params.insurant_certi_no) {
    message = '请填写被保人证件编码'
  } else if (params.insurant_type === '1' && !validateIDCard(params.insurant_certi_no)) {
    message = '请填写合法的被保人身份证号'
  }
  if (message) {
    Toast(message)
    return false
  }
  return true
}

const insurantTypeSelectShow = ref(false)
const insurantTypeSelectTemp = ref('')

function showInsurantTypeSelect() {
  insurantTypeSelectTemp.value = parameter.insurant_type
  insurantTypeSelectShow.value = true
}
function onInsurantTypeSelect(typeItem: InsurantTypeOptionsItem) {
  insurantTypeSelectTemp.value = typeItem.value
}
function confirmInsurantType() {
  if (!insurantTypeSelectTemp.value) {
    return Toast('未选择证件类型')
  }
  let typeV = insurantTypeSelectTemp.value
  let findItem =
    insurantTypeOptions.find((item) => {
      return item.value === typeV
    }) || undefined
  if (!findItem) return
  parameter.insurant_type = findItem.value
  parameter.insurant_type_text = findItem.label
  insurantTypeSelectShow.value = false
}

// 更新平安下载保单
async function updatePinganPrintGac(policyNo: string, needToast = false) {
  try {
    if (needToast) {
      showToastLoading()
    }
    let urlData = await printGAC({
      policyNo,
      electronicType: '04',
      isPrintClause: '0',
    })
    const url = urlData.url
    if (url) {
      sessionStorage.setItem(getPrintGacCacheKey(policyNo), url)
    }
    sessionStorage.removeItem('needUpdatePinganVoucherUrl')
    if (needToast) {
      clearToast()
    }
    return url
  } catch (error) {
    console.log('error', error)
  }
  return ''
}
async function thirdPartyLiabilityData() {
  Page.value.data = []
  try {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    })
    const list = await getPingAnInsuranceList({ sn: route.query.sn as string })
    const sortedList = [...list].sort(
      (a, b) =>
        getThirdPartyInsuranceStatusSortWeight(a.status) -
        getThirdPartyInsuranceStatusSortWeight(b.status)
    )
    if (!sortedList.length) {
      Toast.clear()
      return
    }
    cacheThirdPartyDroneData = sortedList[0]
    Page.value.title = '第三者责任险详情'
    const needUpdatePinganVoucherUrl = !!sessionStorage.getItem('needUpdatePinganVoucherUrl')
    for (const data of sortedList) {
      const pageItem = mapServiceItemToPageItem(data)
      if (
        data.insurance_type === 2 &&
        pageItem.status &&
        (!pageItem.voucher_url || needUpdatePinganVoucherUrl)
      ) {
        const cacheKey = getPrintGacCacheKey(data.policy_no)
        const cached = sessionStorage.getItem(cacheKey)
        if ((!cached || needUpdatePinganVoucherUrl) && data.status) {
          const url = await updatePinganPrintGac(data.policy_no)
          if (url) {
            pageItem.voucher_url = url
          }
        } else if (cached) {
          pageItem.voucher_url = cached
        }
      }
      Page.value.data.push(pageItem)
    }
    Toast.clear()
  } catch (e) {
    Toast.clear()
    console.log('dd', e)
    if ((e as { status: number }).status === 4304) {
      console.log('dd')
      Toast.fail('登录失效,请重新登录后再试')
    } else {
      Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
  }
}

async function extremeServiceData() {
  try {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    })
    let extremeServiceFlag = false
    let data = await getlastXcare({ serial_number: sn as string })
    Page.value.title = '无人机意外机损保险'
    data.forEach((_) => {
      if (_.type === 1) {
        extremeServiceFlag = true
        Page.value.data.push({
          status: extremeServiceStatus[_.status as string].statusNumber,
          pageTitle: _.type_name,
          background: extremeServiceStatus[_.status as string].background,
          text: _.status_text,
          begin_date: dayjs(_.start_at).format('YYYY-MM-DD HH:mm'),
          end_date: dayjs(_.end_at).format('YYYY-MM-DD HH:mm'),
          serial_number: String(sn),
        })
      }
    })
    // 无长度就是极加服务无
    if (!extremeServiceFlag) {
      console.log('wushu')
      Page.value.data.push({
        status: extremeServiceStatus['notService'].statusNumber,
        text: '无服务',
        background: extremeServiceStatus['notService'].background,
        pageTitle: '无人机意外机损保险',
        serial_number: String(sn),
      })
    }
    Toast.clear()
  } catch (e) {
    console.log(e)
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
  }
}

async function allInclusiveServiceData() {
  try {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    })
    let data = await getlastXcare({ serial_number: sn as string })
    Page.value.title = '全保服务'
    data.forEach((_) => {
      if (_.type === 2) {
        Page.value.data.push({
          status: extremeServiceStatus[_.status as string].statusNumber,
          pageTitle: _.type_name,
          background: extremeServiceStatus[_.status as string].background,
          text: _.status_text,
          begin_date: dayjs(_.start_at).format('YYYY-MM-DD HH:mm'),
          end_date: dayjs(_.end_at).format('YYYY-MM-DD HH:mm'),
          serial_number: String(sn),
        })
      }
    })
    Toast.clear()
  } catch (e) {
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
  }
}

async function refreshThirdPartyLiabilityDetailIfNeed() {
  if (SType !== serviceType.ThirdPartyLiabilityService) {
    return
  }
  const refreshSn = sessionStorage.getItem(THIRD_PARTY_DETAIL_REFRESH_KEY)
  if (!refreshSn || refreshSn !== sn) {
    return
  }
  sessionStorage.removeItem(THIRD_PARTY_DETAIL_REFRESH_KEY)
  await thirdPartyLiabilityData()
}

onMounted(async () => {
  switch (SType) {
    case serviceType.ThirdPartyLiabilityService:
      await thirdPartyLiabilityData()
      sessionStorage.removeItem(THIRD_PARTY_DETAIL_REFRESH_KEY)
      break
    case serviceType.ExtremeService:
      await extremeServiceData()
      break
    case serviceType.AllInclusiveService:
      await allInclusiveServiceData()
      break
  }
})

onActivated(() => {
  void refreshThirdPartyLiabilityDetailIfNeed()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: _unref(Page).title,
      onLeftClick: onLeftClick
    }, null, 8, ["title"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Page).data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["content", props.displayMode === 'Landscape' ? 'landscape-width' : '']),
        key: item.policy_no || index
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.pageTitle), 1),
              (item.status !== 0 || !_unref(isThirdPartyLiability))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "设备序列号：" + _toDisplayString(item.serial_number), 1))
                : _createCommentVNode("", true),
              (item.status !== 0 && _unref(isThirdPartyLiability))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "被保人：" + _toDisplayString(item.insurant_name), 1))
                : _createCommentVNode("", true),
              (item.status !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "生效时间：" + _toDisplayString(item.begin_date), 1))
                : _createCommentVNode("", true),
              (item.status !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "到期时间：" + _toDisplayString(item.end_date), 1))
                : _createCommentVNode("", true),
              (item.status !== 0 && _unref(isThirdPartyLiability))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createTextVNode(" NO. " + _toDisplayString(item.policy_no), 1),
                    _hoisted_10,
                    _createTextVNode("由" + _toDisplayString(item.insurance_type_company) + "承保 ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "tag",
              style: _normalizeStyle({ background: item.background })
            }, _toDisplayString(item.text), 5)
          ]),
          (_unref(isThirdPartyLiability) && canShowDownloadPolicy(item))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "action-download",
                  onClick: _withModifiers(($event: any) => (downloadEPolicy(item)), ["stop"])
                }, _toDisplayString(isPPICInsuranceItem(item) ? '下载电子保险凭证' : '下载保单'), 9, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  (canShowOperator(item))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "action-btn action-btn-operator",
                        onClick: _withModifiers(($event: any) => (operator(item)), ["stop"])
                      }, " 操作员 ", 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (canShowCorrectInsured(item))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "action-btn action-btn-correct",
                        onClick: _withModifiers(($event: any) => (handleCorrectInsuredClick(item)), ["stop"])
                      }, _toDisplayString(isPPICInsuranceItem(item) ? '修改被保人' : '批改被保人'), 9, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(isThirdPartyLiability))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (item.status === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                : _createCommentVNode("", true),
              (item.status === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createVNode(_unref(Popup), {
      show: insuredPPICEditShow.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((insuredPPICEditShow).value = $event)),
      "safe-area-inset-bottom": "",
      round: "",
      position: "bottom",
      style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` }),
      class: _normalizeClass(props.displayMode === 'Landscape' ? 'van-popup-landscape-width' : '')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("i", {
              class: "icon-close-svg",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (insuredPPICEditShow.value = false), ["stop"]))
            })
          ]),
          _createElementVNode("div", {
            class: "popup-content with-popuo-bottom",
            style: _normalizeStyle({
          maxHeight: `${_unref(pHeightMax)}px`,
          paddingBottom: `108px`,
        })
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_unref(Field), {
                  style: {"font-size":"16px","line-height":"24px"},
                  modelValue: _unref(parameter).insurant_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(parameter).insurant_name) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请输入被保人名称"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", {
                  class: "item-value",
                  onClick: showInsurantTypeSelect
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", _unref(parameter).insurant_type ? '' : 'no-value'])
                  }, _toDisplayString(_unref(parameter).insurant_type_text || '请选择证件类型'), 3),
                  _hoisted_32
                ])
              ]),
              _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_unref(Field), {
                  style: {"font-size":"16px","line-height":"24px"},
                  modelValue: _unref(parameter).insurant_certi_no,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(parameter).insurant_certi_no) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请输入被保人证件编码"
                }, null, 8, ["modelValue"])
              ])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: confirmEditSuranceInfo
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "style", "class"]),
    _createVNode(_unref(Popup), {
      show: insurantTypeSelectShow.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((insurantTypeSelectShow).value = $event)),
      "safe-area-inset-bottom": "",
      round: "",
      position: "bottom",
      style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` }),
      class: _normalizeClass(props.displayMode === 'Landscape' ? 'van-popup-landscape-width' : '')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("span", {
              class: "back",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (insurantTypeSelectShow.value = false), ["stop"]))
            }, "返回")
          ]),
          _createElementVNode("div", {
            class: "popup-content with-popuo-bottom",
            style: _normalizeStyle({
          maxHeight: `${_unref(pHeightMax)}px`,
          paddingBottom: `128px`,
        })
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(insurantTypeOptions), (typeItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: typeItem.value,
                  class: _normalizeClass(["popup-list-item xag-flex-lr", insurantTypeSelectTemp.value === typeItem.value ? 'selected' : '']),
                  onClick: ($event: any) => (onInsurantTypeSelect(typeItem))
                }, [
                  _createTextVNode(_toDisplayString(typeItem.label) + " ", 1),
                  _hoisted_40
                ], 10, _hoisted_39))
              }), 128))
            ])
          ], 4),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: confirmInsurantType
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "style", "class"])
  ], 64))
}
}

})